import React from 'react';
import {
  Edit,
  SimpleForm,
  NumberInput,
  SelectInput,
  ReferenceField,
  TextField,
  BooleanInput,
  required,
  minValue,
  FormDataConsumer,
} from 'react-admin';

import { TIPOS_CONDICION_TOPE } from '../../enum/tipo-condicion-enum';
import { TIPOS_INTERVALO_TOPE } from '../../enum/tipo-intervalor-enum';

import { redirectToReglaTab } from '../regla/regla-utils';

const redirectToReglaEditTopeTab = (basePath, id) => redirectToReglaTab(id, 'configuraciones'); // solapa Configuraciones

const TopeEdit = (props) => (
  <Edit mutationMode="optimistic" {...props}>
    <SimpleForm warnWhenUnsavedChanges redirect={redirectToReglaEditTopeTab}>
      <ReferenceField
          label="resources.tope.fields.regla"
          source="id"
          reference="regla"
          link="show"
        >
          <TextField source="descripcion"/>
      </ReferenceField>
      <NumberInput source="valor" format={v => (v < 0)? 0 : v} validate={[required(), minValue(1, 'resources.tope.validations.valor.minValue')]}/>
      <SelectInput
        source="tipoCondicion"
        optionText="description"
        optionValue="id"
        choices={TIPOS_CONDICION_TOPE}
        validate={[required()]}
      />
      <SelectInput
        source="tipoIntervalo"
        optionText="description"
        optionValue="id"
        choices={TIPOS_INTERVALO_TOPE}
        validate={[required()]}
      />
      <FormDataConsumer>
        {({ formData }) => formData.tipoIntervalo === 1 &&
            <NumberInput source="cantidadDias" validate={[required()]} defaultValue={0}/>
        }
      </FormDataConsumer>
      <BooleanInput source="porDiagnostico" defaultValue={false} />
      <BooleanInput source="porGrupoPrestacion" defaultValue={false}/>
      <BooleanInput source="porPrestadorEfector" defaultValue={false}/>
    </SimpleForm>
  </Edit>
);

export default TopeEdit;
